module.exports = __webpack_public_path__ + "02b83780d698d63c57c46307b24b54e6.woff";